import api from './api';

/* Колокольчик и тумблеры уведомлений — одинаково для ученика и админа. */
export const getNotifications = (limit = 50) => api.get('/notifications', { params: { limit } });
export const markNotificationsRead = (ids) => api.post('/notifications/read', ids ? { ids } : { all: true });
export const clearNotifications = (ids) => api.post('/notifications/clear', ids ? { ids } : { all: true });
export const getNotifyPrefs = () => api.get('/notifications/prefs');
export const setNotifyPrefs = (patch) => api.put('/notifications/prefs', patch);

/* Telegram: ссылка на бота с одноразовым кодом, отвязка и проверка — привязался
   ли аккаунт (страница опрашивает, пока человек жмёт «Начать» в боте). */
export const linkTelegram = () => api.post('/notifications/telegram/link');
export const unlinkTelegram = () => api.post('/notifications/telegram/unlink');
export const getTelegramStatus = () => api.get('/notifications/telegram/status');
